<div class="d-flex flex-column gap-4">
    <div class="d-inline-block" ngbDropdown container="body" #myDrop="ngbDropdown">
        <a ngbDropdownToggle container="body" class="d-flex justify-content-center sidebar-starter-nav-link">
            <fa-icon icon="clock" size="xl"></fa-icon>
        </a>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <a ngbDropdownItem routerLink="/appointment/0">Create Appointment</a>
            <div class="dropdown-divider"></div>
            <a ngbDropdownItem routerLink="/diary" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                >Diary</a
            >
            <a
                ngbDropdownItem
                routerLink="/diary/timeline"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >Timeline</a
            >
            <a
                ngbDropdownItem
                routerLink="/diary/holiday"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >Holidays</a
            >
            <a
                ngbDropdownItem
                routerLink="/diary/absence"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                >Absences</a
            >
            <a
                ngbDropdownItem
                routerLink="/unallocated-appointments"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                Unallocated Appointments
            </a>
            <div class="dropdown-divider"></div>
            <a ngbDropdownItem routerLink="/staff" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                >View Staff</a
            >
            <button ngbDropdownItem (click)="openStaffMapModal()">View Staff Map</button>
        </div>
    </div>
    <a
        ngbTooltip="View pending appointments"
        container="body"
        class="d-flex justify-content-center sidebar-starter-nav-link"
        (click)="openPendingAppointmentsOffCanvas()">
        <fa-icon icon="calendar-day" size="xl"></fa-icon>
    </a>
    <a
        ngbTooltip="View recently viewed customers"
        container="body"
        class="d-flex justify-content-center sidebar-starter-nav-link"
        (click)="openRecentCustomersOffCanvas()">
        <fa-icon icon="users" size="xl"></fa-icon>
    </a>
    <a
        ngbTooltip="View all staff"
        container="body"
        class="d-flex justify-content-center sidebar-starter-nav-link"
        (click)="openStaffOffCanvas()">
        <fa-icon icon="id-card" size="xl"></fa-icon>
    </a>
    <a
        *ngxPermissionsOnly="'ADMIN'"
        ngbTooltip="View onboarding checklist"
        container="body"
        class="d-flex justify-content-center sidebar-starter-nav-link"
        (click)="openOnboardingChecklist()">
        <fa-icon icon="clipboard-check" size="xl"></fa-icon>
    </a>
    <a
        ngbTooltip="View surefire documentation"
        container="body"
        class="d-flex justify-content-center sidebar-starter-nav-link"
        href="https://surefire-software.gitbook.io/docs/"
        target="_blank">
        <fa-icon icon="file" size="xl"></fa-icon>
    </a>
</div>
